<template>
	<div class="study">
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="famous_second bg_gray">
			<div class="w1200">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/study" class="cl_gray">趣学习</router-link>  >  
							<router-link to="/famous" class="cl_gray">名校试卷</router-link>  >  {{school.name}}</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="famous_down bg_white radius8 f16px">
					<h3 class="f20px">{{school.name}}</h3>
					<h4 class="mat30 f16px"><i class="cl_gray">资料类别： </i><span>{{school.type}}</span></h4>
					<h4 class="mat15 f16px"><i class="cl_gray">软件类型： </i><span>{{school.name}}</span></h4>
					<div class="famous_down_item mat15">
						<p><i class="cl_gray">教材版本： </i><span>{{school.edition_name}}</span></p>
						<p><i class="cl_gray">使用学科： </i><span>{{school.subject_name}}</span></p>
					</div>
					<div class="famous_down_item mat15">
						<p><i class="cl_gray">适用年级： </i><span>{{school.grade_name}}</span></p>
						<p><i class="cl_gray">上传者： </i><span></span></p>
					</div>
					<div class="famous_down_item mat15">
						<p><i class="cl_gray">上传时间： </i><span>{{school.add_time}}</span></p>
					</div>
					<div class="famous_down_btm tc mat30">
						<a :href="school.file" download target="_blank" class="inline cl_white famous_down_btn">立即下载</a>
					</div>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'famous_download',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: 3,
				school: {},
				myInfo: {},
				public: {},
			}
		},
		mounted() {
			this.getMaterial();
		},
		created() {
			this.id = this.$route.query.id;
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getMaterial () {
				this.$get("/api/material/get_material_dtl",{
					id: this.id,
				})
				.then(res => {
					this.school = res.data;
				});
			},
		},
	}
</script>

<style>
</style>
